// removed by extract-text-webpack-plugin
module.exports = {"page-wrapper":"styles__page-wrapper___1lrEW"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Categories/styles.scss
// module id = 317
// module chunks = 0